import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const CTASection = () => {
  const { finalCta } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="relative py-[90px] lg:py-[110px] bg-[#2d6a5a] overflow-hidden">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48ZmlsdGVyIGlkPSJhIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iLjc1IiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsdGVyPSJ1cmwoI2EpIiBvcGFjaXR5PSIuMDMiLz48L3N2Zz4=')] opacity-50 pointer-events-none" />
      
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10 flex flex-col items-center ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-white leading-[1.15] max-w-[540px] text-center tracking-[-0.01em]">
          {finalCta.headline}
        </h2>

        <p className="mt-5 text-[1.05rem] text-white/60 leading-[1.7] max-w-[480px] text-center">
          {finalCta.description}
        </p>

        <Button
          asChild
          className="mt-9 bg-white text-[#2d6a5a] hover:bg-white/90 rounded-full px-7 h-12 text-[0.92rem] font-medium hover:shadow-lg"
          style={{ transition: 'background-color 0.2s, box-shadow 0.3s' }}
        >
          <Link to={finalCta.cta.href}>
            {finalCta.cta.label}
            <ArrowRight className="ml-2" size={17} />
          </Link>
        </Button>
      </div>
    </section>
  );
};
